function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, computed, getCurrentInstance } from "vue";
import { getProjectDownloadResource } from "@pt/api/gmaker/project.js";
import { fetchVersionDownloadResource } from "@/api/creative/custom";
import { downloadWithIframe } from "@/common/download";
import { definePropType } from "@types-vue/props";
import { Message } from "element-ui";
import { t } from "@/lang";
import _ from "lodash";
export default defineComponent({
    props: {
        // 项目类型
        project_type: {
            type: String,
            default: ""
        },
        // 自定义下载方法
        downloadMethods: {
            type: definePropType(Function)
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var loading = ref(false);
        var store = root.$store;
        // 试用套餐无该按钮权限
        var showButton = computed(function() {
            return !store.getters.isPlayableTrial;
        });
        var templateDownload = function(name) {
            // 普通、多组合
            var commonTemplateDownload = function() {
                return {
                    params: {
                        pid: store.state.creative.template.id
                    },
                    request: getProjectDownloadResource
                };
            };
            // 定制
            var versionTemplateDownload = function() {
                return {
                    params: {
                        custom_id: store.state.creative.template.id
                    },
                    request: fetchVersionDownloadResource
                };
            };
            var templateApiUtils = {
                "common-template.custom": commonTemplateDownload,
                "common-template.multi-custom": commonTemplateDownload,
                "template.custom": versionTemplateDownload,
                "template.multi-custom": versionTemplateDownload
            };
            // @ts-ignore
            // eslint-disable-next-line consistent-return
            return templateApiUtils[name]() || null;
        };
        var handleDownloadResource = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var newRequest, apiParams, res, url;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            loading.value = true;
                            if (!props.downloadMethods) {
                                _ctx.next = 6;
                                break;
                            }
                            {
                                newRequest = props.downloadMethods();
                            }
                            _ctx.next = 10;
                            break;
                        case 6:
                            apiParams = templateDownload(props.project_type || root.$store.getters.currentRouter.name);
                            if (apiParams) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error("Fail to download template");
                        case 9:
                            newRequest = apiParams.request(apiParams.params);
                        case 10:
                            _ctx.next = 12;
                            return newRequest.finally(function() {
                                loading.value = false;
                            });
                        case 12:
                            res = _ctx.sent;
                            url = _.get(res, "data.msg") || "";
                            if (url) {
                                Message.success("".concat(t("playTurbo.exportHistory.record.state.success")));
                                downloadWithIframe(url, undefined, true);
                            } else {
                                Message.error("".concat(t("playTurbo.exportHistory.record.state.fail")));
                            }
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function handleDownloadResource() {
                return _ref.apply(this, arguments);
            };
        }();
        return {
            loading: loading,
            showButton: showButton,
            handleDownloadResource: handleDownloadResource
        };
    }
});
